import type { AppLocale } from './locales.ts'

export type LocaleMessageFunction = (...args: never[]) => string
export type LocaleMessageTree = {
  readonly [key: string]: string | LocaleMessageFunction | LocaleMessageTree
}

type LocaleMessageValue = string | LocaleMessageFunction | LocaleMessageTree

type LocaleCatalogShape<T> = {
  readonly [K in keyof T]: T[K] extends (...args: infer P) => string
    ? (...args: P) => string
    : T[K] extends string
      ? string
      : T[K] extends LocaleMessageTree
        ? LocaleCatalogShape<T[K]>
        : never
}

export type LocaleCatalog<T extends LocaleMessageTree> = Readonly<
  { readonly en: T }
  & Record<Exclude<AppLocale, 'en'>, LocaleCatalogShape<T>>
>

export function defineLocaleCatalog<const TEnglish extends LocaleMessageTree>(
  catalogs: Readonly<
    { readonly en: TEnglish }
    & Record<Exclude<AppLocale, 'en'>, LocaleCatalogShape<TEnglish>>
  >,
): LocaleCatalog<TEnglish> {
  return catalogs
}

export function resolveLocaleMessages<T extends LocaleMessageTree>(
  catalog: LocaleCatalog<T>,
  locale: AppLocale,
): LocaleCatalog<T>[AppLocale] {
  return catalog[locale]
}

export type { LocaleCatalogShape, LocaleMessageValue }
